import { CircularProgress, styled } from '@mui/material'
import { circularProgressClasses } from '@mui/material/CircularProgress'
import { UserListItemSkeleton } from '$common/user-list-item'
import { RoomAppBarInfo } from '$common/room-app-bar/room-app-bar-info'
import { messageActionContent } from '$common/chat-list-item-new/hooks/hall-chat-list-item-hooks' // TODO: import from logic
import { useHall } from '$logic/hall/react-hook'
import { useOpenedRoomMessageAction } from '$logic/opened-room/react-hook'
import { openHallProfile } from '$logic/router'
import { toLocale } from '$func/text'
import { t } from '$i18n'
import { HallAppBarCallElement } from '$common/room-app-bar/components/hall-app-bar-call-element'
import { useStartCall } from './react-hooks'
import { HallAvatar } from '$common/avatar'
import hostConf from '$config/frontend'
import { ROOM_APP_BAR_AVATAR_SIZE } from '../conf'
import { useClientUserPermissions } from '$logic/subscription/react-hook'

const hidePrivateHallMemberCount = hostConf.VITE_HIDE_PRIVATE_HALL_MEMBER_COUNT

const StyledCircularProgress = styled(CircularProgress)`
  color: ${({ theme }) => theme.palette.neutral700};
  margin-left: 4px;

  & .${circularProgressClasses.circle} {
    stroke-linecap: round;
  }
`

export function GroupAppBar({ roomId }: { roomId: string }) {
  const { startingCall, openChooseCallDialog, call, canStartCall } =
    useStartCall({ roomId, hallType: 'GROUP' })

  const { entity: hall } = useHall(roomId)
  const messageActions = useOpenedRoomMessageAction()
  const { isAdmin } = useClientUserPermissions(roomId) || {}

  if (!hall) return <UserListItemSkeleton />
  const actionsContent = messageActionContent(messageActions)

  return (
    <RoomAppBarInfo
      onClick={() => openHallProfile(hall.roomId)}
      avatarSrc=""
      primaryText={hall.name}
      avatarElement={
        <HallAvatar
          size={ROOM_APP_BAR_AVATAR_SIZE}
          roomId={hall.roomId}
          withStory
        />
      }
      secondaryText={
        actionsContent ||
        (!hidePrivateHallMemberCount || hall.public || isAdmin
          ? `${toLocale(hall.membersCount)} ${t('profile.hall.member')}`
          : '')
      }
      verified={hall.verified}
      avatarBackgroundColor=""
      deleted={!!hall?.deletedAt}
      callElement={
        call || !canStartCall ? null : startingCall ? (
          <StyledCircularProgress size={24} />
        ) : (
          <HallAppBarCallElement
            onClick={openChooseCallDialog}
            roomType="GROUP"
          />
        )
      }
    />
  )
}
